// Grille tarifaire. Le prix part d'une base et varie selon quatre critères.
// Les extrêmes doivent correspondre à ce qui est annoncé : 56 € et 200 €.

export const BASE = 56;
export const MAX = 200;

export const CRITERIA = [
  {
    key: "duree",
    label: "Durée de la séance",
    why: "Une heure suffit pour corriger un point précis. Deux heures permettent d'enchaîner analyse et mise en pratique.",
    options: [
      { label: "1 heure", delta: 0, note: "Format de base" },
      { label: "1 h 30", delta: 25 },
      { label: "2 heures", delta: 50, note: "Analyse et mise en pratique dans la même séance" },
    ],
  },
  {
    key: "module",
    label: "Module d'entraînement",
    why: "Un module personnalisé demande un travail de préparation en amont : visionnage de vos parties, construction d'exercices adaptés.",
    options: [
      { label: "Standard", delta: 0, note: "Progression structurée, commune à tous" },
      { label: "Personnalisé", delta: 30, note: "Préparé à partir de vos parties et de votre objectif" },
    ],
  },
  {
    key: "jeu",
    label: "Type de jeu",
    why: "Un FPS exige une analyse image par image : visées, timings, placements. La préparation est plus longue.",
    options: [
      { label: "Hors FPS — League of Legends, EA FC", delta: 0 },
      { label: "FPS — Counter-Strike 2, Call of Duty, Fortnite", delta: 20 },
    ],
  },
  {
    key: "competition",
    label: "Préparation à la compétition",
    why: "Au-delà du jeu : règlements des tournois, formats, et construction de schémas de travail répétables en équipe.",
    options: [
      { label: "Non incluse", delta: 0 },
      { label: "Incluse", delta: 44, note: "Formation à la réglementation et développement stratégique" },
    ],
  },
];

// Trois exemples concrets, calculés à partir du tableau ci-dessus.
export const EXAMPLES = [
  {
    title: "Séance de découverte",
    detail: "1 heure · module standard · League of Legends · sans préparation compétition",
    price: 56,
  },
  {
    title: "Travail de fond sur un FPS",
    detail: "1 h 30 · module personnalisé · Counter-Strike 2 · sans préparation compétition",
    price: 131,
  },
  {
    title: "Préparation complète à un tournoi",
    detail: "2 heures · module personnalisé · FPS · préparation compétition incluse",
    price: 200,
  },
];
